<template>
	<CommentActivity
		class="kr-comment-activity"
		:activity="activity"
		translation-namespace="common-gokr.components.KRCommentActivity"
	/>
</template>

<script>
import CommentActivity from "../Activity/CommentActivity.vue";

export default {
	name: "KRCommentActivity",
	components: {
		CommentActivity,
	},
	props: {
		/** { changedBy:String, changedByPicture:String, comment:String, changedAt:String } */
		activity: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
